// extracted by mini-css-extract-plugin
export default {"productDescription":"U_-z","featuredDescription":"V_-z","description":"W_-z","more":"X_-z","descriptionSku":"Y_-z"};